import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
  query FilmMasterVimeoPatch ($id: ID!) {
    FilmMaster (id: $id) {
      ...filmMasterDetail
    Film {
        ...filmDetail
      }
    }
  }
  ${fragments.filmMasterDetail}
  ${fragments.stripDetail}
  ${fragments.filmFileDetail}
  ${fragments.filmMasterPosterFrames}
  ${fragments.filmHost}
  ${fragments.filmFiles}
  ${fragments.artworkDetails}
  ${fragments.filmDetail}
`